export const subtitles = {
    "1": {
        "startTime": 1.633,
        "endTime": 4.299,
        "transcript": "You could turn off the TV. (Yaa.)",
        "translation": "You could turn off the TV. (Okay.)"
    },
    "2": {
        "startTime": 4.477,
        "endTime": 6.355,
        "transcript": "Heck no, we want that.",
        "translation": "Heck no, we want that."
    },
    "3": {
        "startTime": 8.716,
        "endTime": 10.738,
        "transcript": "The TV up there.",
        "translation": "The TV up there."
    },
    "4": {
        "startTime": 11.844,
        "endTime": 13.111,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "5": {
        "startTime": 14.654,
        "endTime": 17.11,
        "transcript": "Au͡girautnayukluku. (Camek yuarcit?)",
        "translation": "It might interfere. (What are you looking for?)"
    },
    "6": {
        "startTime": 17.117,
        "endTime": 19.772,
        "transcript": "Just seeing where those went.",
        "translation": "Just seeing where those went."
    },
    "7": {
        "startTime": 34.763,
        "endTime": 37.519,
        "transcript": "How many minutes ayallrurta?",
        "translation": "How many minutes has it been going?"
    },
    "8": {
        "startTime": 37.525,
        "endTime": 38.158,
        "transcript": "Aa?",
        "translation": "What?"
    },
    "9": {
        "startTime": 38.168,
        "endTime": 40.102,
        "transcript": "How many minutes ayallrurta?",
        "translation": "How many minutes has it been going?"
    },
    "10": {
        "startTime": 40.114,
        "endTime": 41.047,
        "transcript": "Kina?",
        "translation": "Who?"
    },
    "11": {
        "startTime": 41.062,
        "endTime": 42.062,
        "transcript": "Tauna.",
        "translation": "That one."
    },
    "12": {
        "startTime": 42.807,
        "endTime": 45.218,
        "transcript": "Counter-aara tangqerru.",
        "translation": "Look at its counter."
    },
    "13": {
        "startTime": 45.88,
        "endTime": 49.069,
        "transcript": "Thirteen... 1:39.",
        "translation": "Thirteen... 1:39."
    },
    "14": {
        "startTime": 53.014,
        "endTime": 54.67,
        "transcript": "Two minutes piqarraarcelluku.",
        "translation": "Let it go for two minutes."
    },
    "15": {
        "startTime": 54.681,
        "endTime": 55.592,
        "transcript": "Okay.",
        "translation": "Okay."
    },
    "16": {
        "startTime": 55.607,
        "endTime": 59.03,
        "transcript": "You know, tape-aq ayagnirtassiirniartuq.",
        "translation": "You know, so the tape can try starting."
    },
    "17": {
        "startTime": 60.006,
        "endTime": 62.162,
        "transcript": "Qangvaq ayallruceci?",
        "translation": "When did you go?"
    },
    "18": {
        "startTime": 62.452,
        "endTime": 64.574,
        "transcript": "Let's see. When...",
        "translation": "Let's see. When..."
    },
    "19": {
        "startTime": 64.581,
        "endTime": 68.159,
        "transcript": "Qitevtevkenak. Qitevcuumiitellrulriaten iciw.",
        "translation": "Don't speak English. You know, you didn't want to speak English."
    },
    "20": {
        "startTime": 73.908,
        "endTime": 77.308,
        "transcript": "Tuesday-mi atakumi maaken ayallruukut.",
        "translation": "We traveled from here on Tuesday evening."
    },
    "21": {
        "startTime": 77.798,
        "endTime": 79.709,
        "transcript": "Last week-qaa?",
        "translation": "Last week?"
    },
    "22": {
        "startTime": 79.714,
        "endTime": 80.525,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "23": {
        "startTime": 81.209,
        "endTime": 85.198,
        "transcript": "Akmanlluci-llu-qaa one week-arrluci kiingan?",
        "translation": "Were you only there for one week?"
    },
    "24": {
        "startTime": 86.424,
        "endTime": 92.524,
        "transcript": "Pingayiritmi tekitellruukut akmavet, Wednesday morning unuakuayaarmi.",
        "translation": "We arrived over there on Wednesday, early Wednesday morning."
    },
    "25": {
        "startTime": 92.562,
        "endTime": 94.939,
        "transcript": "Mic-aa-qaa alaiciiquq?",
        "translation": "Will her mic be audible?"
    },
    "26": {
        "startTime": 97.19,
        "endTime": 99.379,
        "transcript": "Anchorage-aamun ciungani pilartuten, qaa?",
        "translation": "You've gone to Anchorage before, right?"
    },
    "27": {
        "startTime": 99.39,
        "endTime": 100.723,
        "transcript": "Yaa, yaa.",
        "translation": "Yes, yes."
    },
    "28": {
        "startTime": 100.735,
        "endTime": 103.18,
        "transcript": "Kiturluku-llu-qaa ayaksaunak?",
        "translation": "And have you never gone past it?"
    },
    "29": {
        "startTime": 103.196,
        "endTime": 104.329,
        "transcript": "Ayaksaunii.",
        "translation": "I've never gone."
    },
    "30": {
        "startTime": 104.499,
        "endTime": 106.343,
        "transcript": "Fairbanks-amun tau͡gaam",
        "translation": "Except to Fairbanks."
    },
    "31": {
        "startTime": 107.129,
        "endTime": 114.04,
        "transcript": "Akmavet tekitellerpeni, Alaska-mek maaken anllerpeni akmavet",
        "translation": "When you arrived over there, when you left Alaska here"
    },
    "32": {
        "startTime": 114.569,
        "endTime": 118.747,
        "transcript": "Camek irr'itengqellrusit?",
        "translation": "What were you amazed by?"
    },
    "33": {
        "startTime": 122.085,
        "endTime": 129.496,
        "transcript": "Tua-i-wa tamakunek nunarpagnek angssiyaagpakalrianek, tamakunek ciumek irr'itengqellruunga.",
        "translation": "Well, those big cities that are too big, those were the first things I was amazed by."
    },
    "34": {
        "startTime": 129.896,
        "endTime": 136.73,
        "transcript": "Camek, camek elpeni irrayugluten?",
        "translation": "What was amazing to you?"
    },
    "35": {
        "startTime": 141.181,
        "endTime": 152.037,
        "transcript": "Camek-wa irrayuucuunii. I mean, tangellrenka tamakut pagaaken tangrraqamki angssiyaagpakallratnek.",
        "translation": "I wasn't amazed by anything. I mean, when I saw those things I saw from above, how they were too big."
    },
    "36": {
        "startTime": 152.053,
        "endTime": 153.486,
        "transcript": "Tamatumek.",
        "translation": "That."
    },
    "37": {
        "startTime": 153.492,
        "endTime": 156.581,
        "transcript": "Qaillun ayuqluni un'a tangellren?",
        "translation": "What was what you saw down there like?"
    },
    "38": {
        "startTime": 156.601,
        "endTime": 166.568,
        "transcript": "Tua-i-w' enenek tamakunek mit'eqatarqamta tangllemnek amllessiyaagpakalrianek ucuryuglallruunga.",
        "translation": "When we were going to land, I was in awe how there were too many buildings that I saw."
    },
    "39": {
        "startTime": 169.743,
        "endTime": 172.098,
        "transcript": "Laavkaarpauluteng-qaa?",
        "translation": "Were they big buildings?"
    },
    "40": {
        "startTime": 172.11,
        "endTime": 174.51,
        "transcript": "Laavkaarpauluteng-llu.",
        "translation": "And they were big buildings."
    },
    "41": {
        "startTime": 174.731,
        "endTime": 180.842,
        "transcript": "Tua-i cuculuki maantesqumayaaqluki-ll' tamakut laavkaarpiit ilait.",
        "translation": "I was also envious, wanting some of those big buildings to be here."
    },
    "42": {
        "startTime": 180.852,
        "endTime": 183.807,
        "transcript": "Akiitellratnek tuaten cuculua.",
        "translation": "I also envious of how cheap they were."
    },
    "43": {
        "startTime": 184.606,
        "endTime": 197.603,
        "transcript": "Qaill' aklut-qaa tamakut wani akiitellriit eneqakevkanritait avani maani wani kiputeqarraalallermeggni iciw' akiitellrulriit?",
        "translation": "Didn't those cheap goods make you remember how back when they first started buying things, you know, how cheap they were?"
    },
    "44": {
        "startTime": 197.621,
        "endTime": 199.999,
        "transcript": "Tamana wani qanrutkeqerru.",
        "translation": "Please talk about that."
    },
    "45": {
        "startTime": 200.008,
        "endTime": 212.608,
        "transcript": "Tamakunek umyuarteqellrunritua. Watua tau͡gaam maa-i yugnek umyuarteqellruunga anagulluteng maani cakniussiyaagpakalrianek neqkanek aturanek-llu.",
        "translation": "I didn't think about those. But now, I think about how people here are struggling too much for food and clothes."
    },
    "46": {
        "startTime": 212.613,
        "endTime": 218.624,
        "transcript": "Maa-i watua makut yunraat-llu umyuaqellruanka cakneq.",
        "translation": "Now, I strongly remember these people and the young people."
    },
    "47": {
        "startTime": 220.891,
        "endTime": 224.58,
        "transcript": "Ceńirqurallerpeceńi-mi canek tangaalallrusit?",
        "translation": "When you went visiting, what did you see?"
    },
    "48": {
        "startTime": 225.309,
        "endTime": 235.176,
        "transcript": "Tua-i-w' tamakunek laavkaani canek naunrarnek, uqvialle'rnek-llu uqviamcetun ayuqevkenateng.",
        "translation": "Well, in those buildings, some plants, and some willow trees that aren't like our willows."
    },
    "49": {
        "startTime": 235.693,
        "endTime": 238.971,
        "transcript": "Naucetaanek-ll' amllessiyaagnek tangenrritua.",
        "translation": "And I didn't see too many flowers."
    },
    "50": {
        "startTime": 238.987,
        "endTime": 246.109,
        "transcript": "Ataucinek tau͡gaam imkunek orange-anek, tamakunek tau͡gaam tangellruunga.",
        "translation": "But those single orange ones, I only saw those."
    },
    "51": {
        "startTime": 247.368,
        "endTime": 249.734,
        "transcript": "Atsanek-ll' tangerpek'nii.",
        "translation": "I didn't see berries."
    },
    "52": {
        "startTime": 250.093,
        "endTime": 259.093,
        "transcript": "Cali tamaani umyuarteqellruunga, quyallruunga maani makurmiungullemnek.",
        "translation": "At the time, I was thinking, I am thankful to be from here."
    },
    "53": {
        "startTime": 259.278,
        "endTime": 262.822,
        "transcript": "Iciw' ak'anurpak uitanricaaqua.",
        "translation": "You know, I didn't stay for very long"
    },
    "54": {
        "startTime": 262.825,
        "endTime": 269.403,
        "transcript": "Four, three, four days, taukut iluatni uitayaaqua.",
        "translation": "Four, three, four days, I was there for that time."
    },
    "55": {
        "startTime": 269.421,
        "endTime": 279.255,
        "transcript": "Umyuarteqellruunga qanrucatnga, qanrucanga Bridget-am, \"Waniwa-gguq uksuqaat\"",
        "translation": "I thought when they told me, when Bridget told me, \"This is their winter\""
    },
    "56": {
        "startTime": 280.852,
        "endTime": 290.086,
        "transcript": "Wiinga tua-i tamaanelkuma waniwa, tamaaken wii yuurtellemnek ayagnirlua tamaanelkuma naliak cangalkessanritaqa.",
        "translation": "If I were there now, if I were there starting from when I was born, I wouldn't mind either way."
    },
    "57": {
        "startTime": 290.096,
        "endTime": 305.074,
        "transcript": "Tau͡gaam umyuarteqellruunga, \"Tamaanelkuma waniwa wak'nirnek ayaglua upakuma tamaavet tua-i cakneq, cakneq cupegcartua maavet Alaska-mun.\"",
        "translation": "But I thoughtt, \"If I were there, if I moved there from here on out, I would be very, very homesick for Alaska here.\""
    },
    "58": {
        "startTime": 305.743,
        "endTime": 318.521,
        "transcript": "Umyuarteqlua-llu, umyuarteqaqlua-llu, \"Kaaka, makut waniwa yuut maani elisngiimegteggu-w' cangalkenritlikiit. Taqsuqsuitut.\"",
        "translation": "And I thought, I would think, \"Listen, because these people are used to it here, they don't mind it. They don't get tired.\""
    },
    "59": {
        "startTime": 319.812,
        "endTime": 332.356,
        "transcript": "Wiinga waniwa ukvengama qangvarpak ukanirpak nak'nirnek tayima quyatma ilaklaraat man'a nunavut.",
        "translation": "Since I have gotten faith, since a long time, I'm not sure when, one of the things I'm thankful for is our land here."
    },
    "60": {
        "startTime": 333.543,
        "endTime": 337.91,
        "transcript": "Puqigluni Agayutem taqsuqevkayuunata-llu.",
        "translation": "God, being smart, doesn't make us tired."
    },
    "61": {
        "startTime": 337.913,
        "endTime": 341.602,
        "transcript": "Allrakum iluani cimirluki cat.",
        "translation": "He changes things throughout the year."
    },
    "62": {
        "startTime": 341.611,
        "endTime": 347.155,
        "transcript": "Up'nerkami nunanirpak qanikcaq ayagaqluni, cikuq-ll' ayagaqluni.",
        "translation": "In the spring, it's wonderful when the snow goes, and the ice goes."
    },
    "63": {
        "startTime": 347.158,
        "endTime": 357.358,
        "transcript": "Kiagmi-llu neqnek neqkamteńek uptaqluta neqpignek, atsanek-llu uksurpak pikamteńek.",
        "translation": "And in the summer, we prepare fish for food, salmon, and berries to have all winter."
    },
    "64": {
        "startTime": 358.085,
        "endTime": 365.263,
        "transcript": "Tua-ll' ataam uksurpak uitaluta. Imna qanikcaq, qanikcaq tekican nunaniryugluta.",
        "translation": "Then again in the winter, we stay. When the snow comes, we are joyous."
    },
    "65": {
        "startTime": 365.27,
        "endTime": 370.081,
        "transcript": "Makut-llu eglertessuuteput cimirluteng.",
        "translation": "And our modes of travel change."
    },
    "66": {
        "startTime": 370.285,
        "endTime": 375.096,
        "transcript": "Ikamrarluta, qimugcirluteng-llu ukanirpak pitullrulriit.",
        "translation": "We have sleds, and in the past, they would mush dogs."
    },
    "67": {
        "startTime": 375.11,
        "endTime": 384.854,
        "transcript": "Tua-ll' watua amlleq qimugtairucan amlleq yuk snuukurluni fourwheel-arluni-ll' piyaurrluni.",
        "translation": "Then now, since many don't have dogs, many people have started using snow-gos and fourwheelers."
    },
    "68": {
        "startTime": 385.566,
        "endTime": 388.777,
        "transcript": "Tua-i nunaniqluteng tamakut.",
        "translation": "Those were wonderful."
    },
    "69": {
        "startTime": 388.781,
        "endTime": 393.848,
        "transcript": "Manaryaquluta-ll' cikum aciani anglaniluta piaqluta.",
        "translation": "Then we would go jig in the ice and have fun."
    },
    "70": {
        "startTime": 394.443,
        "endTime": 407.632,
        "transcript": "Tua-ll' ataam up'nerkarluni, ataam qanikcaq taman' nangluni, ataam mer'urrluni, ataam nutaan tamakut cat can'get-llu cimirluteng nutaraurrluteng.",
        "translation": "Then it's winter again, now more snow again, become water again, and those things including grass change to become new again."
    },
    "71": {
        "startTime": 407.655,
        "endTime": 412.6,
        "transcript": "And the berries come again, and the fish come again.",
        "translation": "And the berries come again, and the fish come again."
    },
    "72": {
        "startTime": 413.168,
        "endTime": 416.757,
        "transcript": "Ataam nunaniqluni, taqsuqsuunata.",
        "translation": "It's wonderful again, and we don't get tired."
    },
    "73": {
        "startTime": 417.492,
        "endTime": 427.181,
        "transcript": "Tamaani tuarpiaq wangni nalluamki tayima cat allat iciw' anglanirrlainarluteng piyarngatut.",
        "translation": "At the time, it truly seemed to that because I don't know them, others would, you know, always have fun."
    },
    "74": {
        "startTime": 427.197,
        "endTime": 432.619,
        "transcript": "Wiinga quyaunga maantellemnek Alaska-mi",
        "translation": "I'm thankful that I'm here in Alaska"
    },
    "75": {
        "startTime": 433.337,
        "endTime": 439.903,
        "transcript": "Tamakunek taqsuqevkaqsaunii piliaqestemteńun iciw' pimallra.",
        "translation": "That our creator, you know, doesn't make me tired of those."
    },
    "76": {
        "startTime": 439.915,
        "endTime": 447.204,
        "transcript": "Tua-i ukanirpak tamana nallungramku umyuama-llu tauna ilaklaraat",
        "translation": "Though I've never known in before, that is part of what's in my mind"
    },
    "77": {
        "startTime": 447.221,
        "endTime": 458.054,
        "transcript": "Iciw' taqsuqevkaqsaunata Agayutem cat cimirturluki, cakaput cimirturluki pimallinikiikut.",
        "translation": "You know, that God doesn't make us tired of things by constantly changing them, changing what we will have."
    },
    "78": {
        "startTime": 461.439,
        "endTime": 465.272,
        "transcript": "Cali-qaa unayuqkatgen ayagyuumauten?",
        "translation": "If they invited you again, could you go?"
    },
    "79": {
        "startTime": 465.287,
        "endTime": 468.743,
        "transcript": "Cali unayaqkatnga ayagyallilrianga.",
        "translation": "If they invited me again, I'd probably go."
    },
    "80": {
        "startTime": 468.745,
        "endTime": 478.157,
        "transcript": "Ukanirpak waniwa-w' ukut angliameng irniallrama ayaucungraatnga ayayuitlallruunga.",
        "translation": "Up until now, since my children are grown, though they wanted to travel with me, I wouldn't."
    },
    "81": {
        "startTime": 478.578,
        "endTime": 484.345,
        "transcript": "Iciw' umyuarteqlua maani akirrarmek-ll' qunulua.",
        "translation": "You know, I would think of also being reluctant to spend a little money."
    },
    "82": {
        "startTime": 484.358,
        "endTime": 488.936,
        "transcript": "Ellaita-llu akiuciryungraatnga akirrait qunukluki.",
        "translation": "And though they wanted to give me money, I didn't want them to spend that little money."
    },
    "83": {
        "startTime": 488.947,
        "endTime": 492.069,
        "transcript": "Iciw' paqnayugyuunii-llu canek.",
        "translation": "And, you know, I wouldn't be curious about things."
    },
    "84": {
        "startTime": 492.496,
        "endTime": 499.829,
        "transcript": "TV-ni-ll' tangerrlangramki tuaten-ll' pilarningraitki anagulluni umyuaqa paqnayuyuunani.",
        "translation": "And even when I see them on TV, and they say they do those things, I'm not terribly curious in my mind."
    },
    "85": {
        "startTime": 500.802,
        "endTime": 506.724,
        "transcript": "Tua-ll' waniwa au͡g'um nengauma aanii nangteqngan",
        "translation": "Then now, since my son-in-law's mother is sick"
    },
    "86": {
        "startTime": 507.336,
        "endTime": 519.28,
        "transcript": "Tua-i pinritevkenii qanrutellrani mulungaitniluteng irniatek tamalkuita tangerrsartuuteqatarniluki maurluatnun",
        "translation": "I made sure, when they told me that they wouldn't wait to take all of their children to go see their grandmother"
    },
    "87": {
        "startTime": 519.679,
        "endTime": 524.668,
        "transcript": "Tua-i pinritevkenii wii-ll' maliggnaluki, maligucullruunga.",
        "translation": "I made sure, [because] I wanted to go with them."
    },
    "88": {
        "startTime": 524.68,
        "endTime": 533.025,
        "transcript": "Apepailgatnga-ll', iciw' wiinga-ll' piyullemnek apepailgatnga wangnek maligcugluki maligtellruanka",
        "translation": "And before they asked me, you know, before they asked me if I wanted to, I went with them since I wanted to go myself"
    },
    "89": {
        "startTime": 533.036,
        "endTime": 540.147,
        "transcript": "Kenekngamku tauna maurluat meet-allruamku ak'a ciungani malrurqugnek.",
        "translation": "Because I loved their grandmother since I'd met her twice in the past."
    },
    "90": {
        "startTime": 540.165,
        "endTime": 547.287,
        "transcript": "Ellminek tailuni maavet kassuuteqatallragni. Meet-allruaqa tamaani.",
        "translation": "She came of her own accord when they were going to get married. I met her then."
    },
    "91": {
        "startTime": 547.288,
        "endTime": 557.244,
        "transcript": "Ataam-llu call' kinguakun cali irniangumarilukek ataam cali tailuni cali sister-aminek cousin-aminek-ll' malilirluni.",
        "translation": "Then again afterwards, when they'd had children, she came again along with her sister and her cousin."
    },
    "92": {
        "startTime": 557.251,
        "endTime": 563.651,
        "transcript": "Wiinga-ll' ataam ullagluki maani, maani quyungqaluta uitallruukut.",
        "translation": "Then I went to them again here, and we'd stay here together."
    },
    "93": {
        "startTime": 563.968,
        "endTime": 574.457,
        "transcript": "Iciw' kenekngamku, au͡g'umek-llu qetunrarminek cikipigainarluta cikirngakut",
        "translation": "You know, because I loved her, and she'd completely given us her son"
    },
    "94": {
        "startTime": 575.337,
        "endTime": 586.771,
        "transcript": "Iciw' cangalkenrilamku, amllernek-llu wii angutnek irniangqenrilama kenekluku ilakarput.",
        "translation": "You know, because I had no qualms with her, and since I don't have a lot of male children, we love him as our own."
    },
    "95": {
        "startTime": 586.781,
        "endTime": 590.314,
        "transcript": "Cali aanii tauna wii kenekluku.",
        "translation": "I also loved his mother."
    },
    "96": {
        "startTime": 591.068,
        "endTime": 597.024,
        "transcript": "Ilutequatekluku-llu au͡g'um panillera'urluma piyuilaku.",
        "translation": "Also because my dear daughter didn't have grievances against her."
    },
    "97": {
        "startTime": 597.474,
        "endTime": 605.097,
        "transcript": "Cakneq tua-i allragnirpak takumcukluku wangnun elliqluku ayaasqumalaranka ukut.",
        "translation": "Since last year, out of great pity for her, [?I bring it upon myself] to ask them to go."
    },
    "98": {
        "startTime": 608.359,
        "endTime": 611.359,
        "transcript": "Ullaasqumalallruaqa.",
        "translation": "I'd tell them to go to her."
    },
    "99": {
        "startTime": 612.218,
        "endTime": 621.129,
        "transcript": "Nulirqeqatallragni tamaani pisqellrunricaaqaqa cakneq ayaulluku akmavet peggluku nanikuavkarnayukluku.",
        "translation": "Back when they were going to get married, I really didn't want her to in case he might bring her over there, abandon her, and make her feel helpless."
    },
    "100": {
        "startTime": 621.835,
        "endTime": 627.48,
        "transcript": "Tauna piciunritlinian maa-i cakneq kenekluku.",
        "translation": "Since that wasn't true, I love him a lot now."
    },
    "101": {
        "startTime": 627.499,
        "endTime": 639.265,
        "transcript": "Cingumaluki-llu ayaasqaqluki ullaasqelluku tauna maurluat takumcukluku cakneq, kiirraan-ll' irniaqelliniaku",
        "translation": "And I encourage them to go to see their grandmother out of great pity for her, also because he's her only child"
    },
    "102": {
        "startTime": 639.652,
        "endTime": 649.508,
        "transcript": "Nallunrilamku qaillun irniami keneknarqetacia, tutagara'urlumi-ll' keneknarqetaciit qaillun nallunrilamku.",
        "translation": "Because I know how much one loves their chidlren, and because I know how much one loves their grandchildren."
    },
    "103": {
        "startTime": 649.518,
        "endTime": 658.541,
        "transcript": "Tua-i wangcetun ayuqsukluku cakneq cingumalallruanka allragnirpak.",
        "translation": "Thinking that she was like me, I'd encourage them a lot all last year."
    },
    "104": {
        "startTime": 660.954,
        "endTime": 675.22,
        "transcript": "Camek tayima qanqeryukuvet. Aptellrunrilkengamnek akmavet ayallerpenek qaneryukuvet wall' qaneryuumiilkuvet.",
        "translation": "You can say something else. You can say something about what I haven't asked you about your travels out there, or if you don't want to."
    },
    "105": {
        "startTime": 675.623,
        "endTime": 683.179,
        "transcript": "Tua-i-w' irr'iyullemnek-llu canek angelrianek aptellrukevnga, apcaaqekevnga au͡ga-i.",
        "translation": "You also just asked me about what big thigns I was amazed by over there."
    },
    "106": {
        "startTime": 685.205,
        "endTime": 687.971,
        "transcript": "Irr'iyullruunga au͡gkunek...",
        "translation": "I was amazed by those..."
    },
    "107": {
        "startTime": 691.071,
        "endTime": 698.371,
        "transcript": "TIme-angqenrilami anagulluta ayagatellrunritaakut canun au͡g'um ayagatestemta.",
        "translation": "Since [s]he didn't have time, our escort didn't take us to a lot of things."
    },
    "108": {
        "startTime": 699.57,
        "endTime": 703.926,
        "transcript": "Tau͡gaam Saturday-mi... let's see.",
        "translation": "But on Saturday... let's see."
    },
    "109": {
        "startTime": 703.933,
        "endTime": 708.766,
        "transcript": "Yaa, Maqinermi ayagatellruakut.",
        "translation": "Yes, [s]he brought us around on Saturday."
    },
    "110": {
        "startTime": 708.769,
        "endTime": 714.625,
        "transcript": "Canun taukunun ayauskilikut qunguturanun mermiutarnun.",
        "translation": "[S]he brought us to an aquarium."
    },
    "111": {
        "startTime": 717.124,
        "endTime": 726.724,
        "transcript": "Sea otters, whales, tamakut ellicaumalliniluteng. Cakneq irr'inaqluteng.",
        "translation": "Sea otters, whales, those were penned. They were very amazing."
    },
    "112": {
        "startTime": 726.741,
        "endTime": 731.53,
        "transcript": "Tamakunek tua-i, arcaqerlua-ll' tamakunek irr'iyullruunga.",
        "translation": "Those, I was especially in awe of those."
    },
    "113": {
        "startTime": 731.542,
        "endTime": 742.831,
        "transcript": "\"Atak' tamakut ellicartait,\" umyuarteqlua, \"Angli-lli tamakuni ellicartaitni iciw' they have patience.\"",
        "translation": "\"Look, their keepers,\" I thought, \"Wow, their keepers are so, you know, they have patience.\""
    },
    "114": {
        "startTime": 744.267,
        "endTime": 748.811,
        "transcript": "Qenqercuunateng kaaka tayima ellicamaita ak'aki.",
        "translation": "They don't get angry, listen, as they pen so many."
    },
    "115": {
        "startTime": 750.058,
        "endTime": 755.025,
        "transcript": "Tua-i cakneq casqaqaiceteng canaurtut tamakut.",
        "translation": "When they were commanded, those [animals] would do things."
    },
    "116": {
        "startTime": 755.993,
        "endTime": 763.104,
        "transcript": "Nepliisqaqaceteng-ll' nepliqluteng. Quyurnisqaqaiceteng-ll' quuyurniaqluteng.",
        "translation": "When they were told to make a sound, they made the sound. When they were told to smile, they smiled."
    },
    "117": {
        "startTime": 764.788,
        "endTime": 772.155,
        "transcript": "Tamakunek cakneq irr'iyullruunga tua-i cakneq. Taukunek angelrianek irr'iyupiarallruunga.",
        "translation": "I was very amazed by those. I was amazed by those large [animals]."
    }
};